<template>
  <div class="cards">
    <div class="card" :key="quote.id" v-for="quote in quotes">
        <div class="user">
          <img
            class="user__img"
            :alt="quote.name"
            :src="require(`../../assets/sps/${quote.image_url}`)"
          />
          <div class="user__details">
            <div class="user__name">{{quote.name}}</div>
            <div class="user__status">{{quote.status}}</div>
          </div>
        </div>
        <div class="card__text">
          {{`"${quote.text}"`}}
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    quotes: Array,
  },
};
</script>

<style lang="scss" scoped>

  .cards {
    margin-top: var(--bg-spacer);
    color: var(--white);
    text-align: left;

    .card {
      padding: var(--sm-spacer);
      background-color: var(--very-dark-magenta);
      margin-bottom: var(--sm-spacer);
      border-radius: var(--border-radius);
    }
  }

  .user {
    display: flex;
    grid-gap: var(--sm-spacer);
    margin-bottom: var(--sm-spacer);

    &__img {
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
    }

    &__name {
      font-weight: 700;
    }

    &__status {
      color: var(--soft-pink);
      font-size: var(--fs-small);
    }
  }

  @media (min-width: 50em) {
    .cards {
      display: flex;
      column-gap: var(--sm-spacer);

      .card {
        margin-bottom: 0;
        &:nth-child(2) {
          transform: translateY(var(--sm-spacer));
        }

        &:nth-child(3) {
          transform: translateY(var(--bg-spacer));
        }
      }
    }
  }
</style>
